import { put, takeEvery, call } from 'redux-saga/effects';

import {
  DETAILS_FORM_AGREEMENTS_MARKETING_GET,
  accountFormAgreementsMarketingSet, accountFormAgreementsFetchError
} from 'src/app/redux/actions/registration/account/accountFormAgreementsMarketing';
import agreementsApi from 'src/app/api/agreementsApi';
import { firstLetterLowercase } from 'src/app/api/camelize';


function getMarketingAgreements(agreementsRequest, agreementsCodes) {
  return function* getMarketingAgreementsGenerator() {
    const request = yield agreementsRequest(agreementsCodes)
      .then(function* onSuccess({ data }) {
        const agreements = data.map(agreement => ({ ...agreement, checked: false }));

        return yield put(accountFormAgreementsMarketingSet(firstLetterLowercase(agreements)));
      })
      .catch(function* onError() { return yield put(accountFormAgreementsFetchError()); });

    yield call(() => request);
  };
}

export { getMarketingAgreements };

export default [
  takeEvery(
    DETAILS_FORM_AGREEMENTS_MARKETING_GET,
    getMarketingAgreements(
      agreementsApi.getAgreements,
      agreementsApi.prepareAgreementsURLParams([
        'gp-commercial-information-by-email',
        'available-for-employer',
        'customers-commercial-information-by-email'
      ]))
  )
];

